import { render, staticRenderFns } from "./courseCategory.vue?vue&type=template&id=7d24e9c0&"
import script from "./courseCategory.vue?vue&type=script&lang=js&"
export * from "./courseCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports